import { css } from 'jimu-core';
import { buttonVariantStyles } from './button';
import { getBoxStyles } from 'jimu-theme';
function getRootStyles(rootVars) {
    return getBoxStyles(rootVars);
}
function getItemStyles(stateVars) {
    return stateVars && css `
    .jimu-btn {
      &.previous,
      &.next {
        ${buttonVariantStyles(stateVars)}
      }
    }
  `;
}
function getVariantStyles(variantVars) {
    return variantVars && css `
    ${getRootStyles(variantVars === null || variantVars === void 0 ? void 0 : variantVars.root)}
    ${getItemStyles(variantVars === null || variantVars === void 0 ? void 0 : variantVars.item)}
  `;
}
const iconSpace = '5px';
export const navButtonGroupStyles = (props) => {
    var _a, _b, _c, _d;
    const theme = props.theme;
    const type = (_a = props === null || props === void 0 ? void 0 : props.type) !== null && _a !== void 0 ? _a : 'default';
    const vertical = props === null || props === void 0 ? void 0 : props.vertical;
    const previous = (props === null || props === void 0 ? void 0 : props.previousText) && (props === null || props === void 0 ? void 0 : props.previousIcon);
    const next = (props === null || props === void 0 ? void 0 : props.nextText) && (props === null || props === void 0 ? void 0 : props.nextIcon);
    const variant = (_d = (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.components) === null || _b === void 0 ? void 0 : _b.navButtonGroup) === null || _c === void 0 ? void 0 : _c.variants) === null || _d === void 0 ? void 0 : _d[type];
    return css `
    width: 100%;
    height: 100%;
    min-height: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: ${vertical ? 'column' : 'row'};
    ${getVariantStyles(variant)};
    .jimu-keyboard-nav & .direction-button:focus {
      outline: auto
    }
    > .jimu-btn.icon-btn.btn {
      padding: 0.125rem;
      &.previous {
        > .icon-btn-sizer {
          justify-content:${previous ? 'flex-start' : 'center'};;
          >.jimu-icon {
            margin-right: ${previous ? iconSpace : 'unset'};
            margin-left: unset;
          }
        }
      }
      &.next {
        > .icon-btn-sizer {
          justify-content:${next ? 'flex-end' : 'center'};;
          >.jimu-icon {
            margin-left: ${next ? iconSpace : 'unset'};
            margin-right: unset;
          }
        }
      }
    }
  `;
};
export const navButtonGroupStyleUtils = { getRootStyles, getItemStyles, getVariantStyles };
